import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Tjyd from '../../../../components/tjyd/';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { Share } from '@ifeng-fe/ui_pc_share';
import { trim } from '@ifeng-fe/container_channel/common/client/winter/utils/utils';

class NewsListItem extends React.PureComponent {
    state = {
        docUrl: '',
        commentCount: '',
    };

    static propTypes = {
        initNewsData: PropTypes.object,
        commentCount: PropTypes.object,
    };

    UNSAFE_componentWillMount() {
        const commentUrl = this.props.initNewsData.commentUrl;

        this.setState({
            docUrl: commentUrl,
        });
    }
    componentDidMount() {}

    /**
     * 格式化时间
     */
    formatTime(time) {
        const time1 = trim(time, 'g');

        const day = time1.substr(8, 2);

        const today = new Date().getDate();

        if (day !== today) {
            return time;
        } else {
            return time1.substr(10, 5);
        }
    }
    /**
     * 渲染网页布局
     */
    render() {
        const { initNewsData, commentCount } = this.props;

        const config = {
            items: ['sina', 'wechat', 'qqzone'],
            display: 'normal',
            hover: 'hover',
            type: 'horizontal',
            methods: 'hover',
            tooltip: 'top',
        };

        const shareInfo = {
            url: initNewsData.url,
            title: initNewsData.title,
            summery: initNewsData.title,
            picUrl: initNewsData.thumbnail,
        };

        /**
         * 组件分发数据
         */
        return (
            <div className={styles.newsListItem}>
                <span className={styles.time}>{this.formatTime(initNewsData.newsTime)}</span>
                <h1>
                    <a href={initNewsData.type === 'web' ? initNewsData.url : `https://news.ifeng.com/c/${initNewsData.base62Id}`} target="_blank">
                        {initNewsData.title}
                    </a>
                </h1>
                <p>{initNewsData.summary}</p>
                <div className={styles.clearfix}>
                    <Tjyd linkUrl={initNewsData.type === 'web' ? initNewsData.url : `https://news.ifeng.com/c/${initNewsData.base62Id}`} />
                    <div className={styles.shareBox}>
                        <div className={styles.recom}>
                            <a
                                href={`http://gentie.ifeng.com/view.html?docName=${initNewsData.title}&docUrl=${
                                    initNewsData.commentUrl
                                }&pcUrl=${initNewsData.url}`}
                                target="_blank">
                                {commentCount[initNewsData.commentUrl] ? commentCount[initNewsData.commentUrl] : 0}
                            </a>
                        </div>
                        <h3>分享</h3>
                        <div className={styles.shareInner}>
                            <Share config={config} shareInfo={shareInfo} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default errorBoundary(NewsListItem);
